/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ColleaguesInputs */

const en_nav_colleagues = /** @type {(inputs: Nav_ColleaguesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colleagues`)
};

const ja_nav_colleagues = /** @type {(inputs: Nav_ColleaguesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同僚`)
};

const fr_nav_colleagues = /** @type {(inputs: Nav_ColleaguesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collègues`)
};

const de_nav_colleagues = /** @type {(inputs: Nav_ColleaguesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kollegen`)
};

/**
* | output |
* | --- |
* | "Colleagues" |
*
* @param {Nav_ColleaguesInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_colleagues = /** @type {((inputs?: Nav_ColleaguesInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ColleaguesInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_colleagues(inputs)
	if (locale === "ja") return ja_nav_colleagues(inputs)
	if (locale === "fr") return fr_nav_colleagues(inputs)
	return de_nav_colleagues(inputs)
});